export default {
  buyNow: {
    unavailable: "That game isn't available right now — nothing was added to your cart.",
    limitReached: 'Cart limit reached ({limit} per transaction) — the game was not added.',
  },
  heading: 'Checkout',
  subheading: 'Review and place your order',

  empty: {
    title: 'Your cart is empty.',
    hint: 'Add a few keys before checking out.',
    browseCatalog: 'Browse catalog',
  },

  wallet: {
    sectionLabel: 'Payment method — wallet',
    available: 'available',
    covers: 'Covers this order',
    topUpAmount: 'Top up {diff}',
  },

  billing: {
    sectionLabel: 'Billing information',
    editInSettings: 'Edit in Settings →',
    fieldName: 'Name',
    fieldEmail: 'Email',
    fieldCountry: 'Country',
    fieldDateOfBirth: 'Date of birth',
    fieldAddress: 'Address',
    missingTitle: 'Billing address missing',
    missingHint: 'Add your address in Settings before you can place an order.',
  },

  profileGate: {
    title: 'Profile incomplete',
    hint: 'Still needed before checkout:',
    completeProfile: 'Complete profile →',
  },

  order: {
    sectionLabel: 'Your order',
  },

  placed: {
    chip: 'Order placed',
    title: 'Your order is in',
    body: 'Taking you to your order…',
  },

  errors: {
    lineFailed: 'Failed',
    placeFailed: 'Could not place all orders',
    partialFailureTitle: "Some items couldn't be ordered:",
    partialFailureNote: 'Successful items have been moved to your orders. The rest remain in your cart.',
  },

  aside: {
    totalToPay: 'Total to pay',
    walletDeduction: 'Will be deducted from your wallet',
    placeOrder: 'Place order',
    placingOrder: 'Placing order…',
    legalBefore: 'By placing your order, you agree to our',
    legalBetween: 'and',
    tc: 'T&C',
    privacy: 'Privacy Policy',
    instantDelivery: 'Keys delivered instantly',
  },

  topupReturn: {
    loadingError: 'Could not load top-up status',
    missingRef: 'Missing payment reference',
    timedOut: {
      title: 'Still pending',
      body: "The provider hasn't confirmed yet. You won't be charged twice — refresh this page later or open your wallet to see the credit when it lands.",
    },
    status: {
      PENDING: {
        title: 'Waiting for confirmation…',
        sub: 'The payment provider will confirm shortly. This page updates automatically.',
      },
      COMPLETED: {
        title: 'Top-up successful',
        sub: 'Your wallet has been credited.',
      },
      FAILED: {
        title: 'Top-up failed',
        sub: 'The payment was not completed. You have not been charged.',
      },
      REFUNDED: {
        title: 'Top-up refunded',
        sub: 'The payment was reversed by the provider.',
      },
    },
    waitingSeconds: "Waiting {elapsed}s · we'll update automatically",
    redirecting: 'Redirecting to wallet…',
    backToBilling: 'Back to billing',
  },
};
